import { BrowserRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "react-hot-toast";
import "./assets/scss/style.scss";

import App from "./App.jsx";
import store from "./store/index";
import { persistedStore } from "./store/index";
import ErrorBoundary from "./shared/Components/UI/ErrorBoundary.jsx";
import { queryClient } from "./utils/queryClientUtil.js";
import { SocketProvider } from "./shared/provider/SocketProvider.jsx";

// if (process.env.NODE_ENV === "production") {
//   console.log = () => {};
//   console.error = () => {};
//   console.warn = () => {};
//   console.debug = () => {};
// }

createRoot(document.getElementById("root")).render(
  <ErrorBoundary>
    <BrowserRouter>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistedStore}>
          <SocketProvider>
            <QueryClientProvider client={queryClient}>
              <App />
              <Toaster />
            </QueryClientProvider>
          </SocketProvider>
        </PersistGate>
      </Provider>
    </BrowserRouter>
  </ErrorBoundary>,
);
